import create from "../utils/request"

export function login(data) {
    return create({
        url: "admin/login",
        method: "post",
        data: data
    })
}

export function registry(data) {
    return create({
        url: "admin/registry",
        method: "post",
        data: data
    })
}

export function loginout() {
    return create({
        url: "admin/loginout",
        method: "post",
        // data: data
    })
}

export function userInfo() {
    return create({
        url: "admin/userInfo",
        method: "get",
    })
}

export function uploadPic(data) {
    return create({
        url: "/fileUpload",
        method: "post",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

export function updateUserInfo(data) {
    return create({
        url: "/admin/update",
        method: "put",
        data: data
    })
}

export function resetPassword(data) {
    return create({
        url: "/admin/resetPws",
        method: "put",
        data: data
    })
}

export function sendValidateCode(params) {
    return create({
        url: "/admin/sendValidateCode",
        method: "get",
        params: params
    })
}

export function loginWithPhone(data) {
    return create({
        url: "/admin/loginWithPhone",
        method: "post",
        data: data
    })
}
